import React from "react";
import useAuth from "../../routes/login/AuthContext";

import { Button } from "../../UI/Button";

interface IProps {
  url: string;
}

export const RequestChangeButton: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const handleChangeRequestClick = () => window.open(props.url, "_blank", "noopener");

  return (
    <Button appearance="primary" onClick={handleChangeRequestClick} isDisabled={isSuperAdminRead()}>
      Request a Change
    </Button>
  );
};
